export const userProfileKeys = {
	all: ['userProfile'],
	detail: (userId) => [...userProfileKeys.all, userId],
};
